/**
 * SOLIDWORKS 阵列跳过选择点的洋红色。
 *
 * 线性阵列的可选标记与圆周草图阵列的已跳过标记共用该色值，
 * 禁止各阵列预览重复声明颜色常量。
 */
export const PATTERN_SKIP_MARKER_MAGENTA_COLOR = 0xff00ff;
